module.exports = __webpack_public_path__ + "static/media/lineCopy1.2b900e19.svg";